export class LocalStorage {
    public static deletePreffix(preffix: string): void {
        Object.keys(localStorage)
            .filter(x => x.startsWith(preffix))
            .forEach(x => localStorage.removeItem(x));
    }
}
